import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "entry-column--pagination"
}
const _hoisted_2 = { class: "column-item--header" }
const _hoisted_3 = {
  key: 0,
  class: "column-item--content"
}
const _hoisted_4 = {
  key: 0,
  class: "column-item--editor"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_6 = {
  key: 2,
  class: "placeholder"
}
const _hoisted_7 = { class: "column-item--header" }
const _hoisted_8 = {
  key: 0,
  class: "column-item--content"
}
const _hoisted_9 = {
  key: 0,
  class: "column-item--editor"
}
const _hoisted_10 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_11 = {
  key: 3,
  class: "entry-column--list table-view"
}
const _hoisted_12 = { class: "column-item--metadata" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_list_header = _resolveComponent("list-header")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_entry_item = _resolveComponent("entry-item")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_table_list_view = _resolveComponent("table-list-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["entry-column", _ctx.columnClassList]),
    style: _normalizeStyle(`width: ${_ctx.width}`)
  }, [
    (_ctx.name)
      ? (_openBlock(), _createBlock(_component_list_header, {
          key: 0,
          title: _ctx.STATUS.get(_ctx.name) ? (_ctx.STATUS.get(_ctx.name).customLabel || _ctx.STATUS.get(_ctx.name).label) : (_ctx.name === 'null' || _ctx.name === 'undefined' ? '' : _ctx.name),
          subtitle: _ctx.subtitle
        }, {
          meta: _withCtx(() => [
            (_ctx.pageState.total > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_q_pagination, {
                    modelValue: _ctx.pageState.current,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageState.current) = $event)),
                    max: _ctx.pageState.total,
                    "max-pages": 7,
                    input: "",
                    "boundary-links": false,
                    unelevated: "",
                    dense: ""
                  }, null, 8, ["modelValue", "max"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "subtitle"]))
      : _createCommentVNode("", true),
    (_ctx.view === _ctx.ColumnView.Horizontal)
      ? _renderSlot(_ctx.$slots, "content-horizontal", { key: 1 }, () => [
          (_ctx.items.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["entry-column--list horizontal-list", _ctx.columnClassList]),
                style: _normalizeStyle(`--content-count: ${(_ctx.items?.length || 1) + 1}`),
                id: "horizontal-scrol-list"
              }, [
                (_ctx.expanded[0] !== _ctx.items[0].sys.id)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      class: "hover-button left-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToNextElement('ArrowLeft')))
                    }))
                  : _createCommentVNode("", true),
                (_ctx.expanded[0] !== _ctx.items[_ctx.items.length-1].sys.id)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      class: "hover-button right-button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToNextElement('ArrowRight')))
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageState.items, (item, i) => {
                  return (_openBlock(), _createBlock(_component_entry_item, {
                    class: _normalizeClass(["ozn-entry-list__list-item expandable", {active: _ctx.expanded.includes(item.sys.id), warn: _ctx.warned.includes(item.sys.id)}]),
                    ref_for: true,
                    ref: e => _ctx.elements[i] = e,
                    entry: item,
                    size: "small",
                    highlight: _ctx.expanded.includes(item.sys.id),
                    key: item.sys.id,
                    "data-cy": "entry-list-expandable",
                    onSelect: ($event: any) => (_ctx.emit('select', item)),
                    onActive: ($event: any) => (_ctx.emit('active', item)),
                    onExpand: e => _ctx.toggleExpandItem(item, null, e)
                  }, {
                    header: _withCtx(({ entry, actions }) => [
                      _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "item-header", {
                          entry: entry,
                          expanded: _ctx.expanded,
                          expand: (n, e) => _ctx.toggleExpandItem(item, actions.setProp, e),
                          cache: _ctx.cache,
                          actions: actions,
                          elements: _ctx.elements,
                          index: _ctx.pageState.offset + i
                        }, undefined, true)
                      ])
                    ]),
                    content: _withCtx(({ entry, actions }) => [
                      (!_ctx.expandable || _ctx.expanded.includes(item.sys.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _renderSlot(_ctx.$slots, "item-content", {
                              entry: entry,
                              expanded: _ctx.expanded,
                              expand: (n, e) => _ctx.toggleExpandItem(item, actions.setProp, e),
                              cache: _ctx.cache,
                              actions: actions,
                              elements: _ctx.elements,
                              index: _ctx.pageState.offset + i
                            }, undefined, true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    editor: _withCtx(({ entry, actions }) => [
                      (!_ctx.expandable || _ctx.expanded.includes(item.sys.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "item-editor", {
                              entry: entry,
                              expanded: _ctx.expanded,
                              expand: (n, e) => _ctx.toggleExpandItem(item, actions.setProp, e),
                              cache: _ctx.cache,
                              actions: actions,
                              elements: _ctx.elements,
                              index: _ctx.pageState.offset + i
                            }, undefined, true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["entry", "highlight", "class", "onSelect", "onActive", "onExpand"]))
                }), 128))
              ], 6))
            : (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_spinner, {
                    scale: 0.5,
                    visible: true,
                    style: {"margin":"0 auto","width":"50px"}
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, "No items to display"))
        ], true)
      : _createCommentVNode("", true),
    (_ctx.view === _ctx.ColumnView.Vertical)
      ? _renderSlot(_ctx.$slots, "content-vertical", { key: 2 }, () => [
          (_ctx.items.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["entry-column--list vertical-list", _ctx.columnClassList])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageState.items, (item, i) => {
                  return (_openBlock(), _createBlock(_component_entry_item, {
                    class: _normalizeClass(["ozn-entry-list__list-item expandable", {active: _ctx.expanded.includes(item.sys.id), warn: _ctx.warned.includes(item.sys.id)}]),
                    ref_for: true,
                    ref: e => _ctx.elements[i] = e,
                    entry: item,
                    size: "small",
                    highlight: _ctx.expanded.includes(item.sys.id),
                    key: item.sys.id,
                    onSelect: ($event: any) => (_ctx.emit('select', item)),
                    onActive: ($event: any) => (_ctx.emit('active', item)),
                    onExpand: e => _ctx.toggleExpandItem(item, null, e)
                  }, {
                    header: _withCtx(({ entry, actions }) => [
                      _createElementVNode("div", _hoisted_7, [
                        _renderSlot(_ctx.$slots, "item-header", {
                          entry: entry,
                          expanded: _ctx.expanded,
                          expand: (n, e) => _ctx.toggleExpandItem(item, actions.setProp, e),
                          cache: _ctx.cache,
                          actions: actions,
                          elements: _ctx.elements,
                          index: _ctx.pageState.offset + i,
                          header: _ctx.name,
                          type: _ctx.type
                        }, undefined, true)
                      ])
                    ]),
                    content: _withCtx(({ entry, actions }) => [
                      (!_ctx.expandable || _ctx.expanded.includes(item.sys.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _renderSlot(_ctx.$slots, "item-content", {
                              entry: entry,
                              expanded: _ctx.expanded,
                              expand: (n, e) => _ctx.toggleExpandItem(item, actions.setProp, e),
                              cache: _ctx.cache,
                              actions: actions,
                              elements: _ctx.elements,
                              index: _ctx.pageState.offset + i,
                              header: _ctx.name,
                              type: _ctx.type
                            }, undefined, true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    editor: _withCtx(({ entry, actions }) => [
                      (!_ctx.expandable || _ctx.expanded.includes(item.sys.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _renderSlot(_ctx.$slots, "item-editor", {
                              entry: entry,
                              expanded: _ctx.expanded,
                              expand: (n, e) => _ctx.toggleExpandItem(item, actions.setProp, e),
                              cache: _ctx.cache,
                              actions: actions,
                              elements: _ctx.elements,
                              index: _ctx.pageState.offset + i,
                              header: _ctx.name,
                              type: _ctx.type
                            }, undefined, true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["entry", "highlight", "class", "onSelect", "onActive", "onExpand"]))
                }), 128))
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, "No items to display"))
        ], true)
      : _createCommentVNode("", true),
    (_ctx.view === _ctx.ColumnView.Table)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.view === _ctx.ColumnView.Table)
            ? _renderSlot(_ctx.$slots, "content-table", { key: 0 }, () => [
                _createVNode(_component_table_list_view, {
                  class: _normalizeClass(_ctx.columnClassList),
                  items: _ctx.pageState.items
                }, {
                  header: _withCtx(({ entry, index }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["column-item--header", {active: _ctx.expanded.includes(entry.sys.id)}])
                    }, [
                      _renderSlot(_ctx.$slots, "item-header", {
                        entry: entry,
                        expanded: _ctx.expanded,
                        expand: (n, e) => _ctx.toggleExpandItem(entry, undefined, e),
                        cache: _ctx.cache,
                        actions: {},
                        elements: _ctx.elements,
                        index: _ctx.pageState.offset + index,
                        header: _ctx.name,
                        type: _ctx.type
                      }, undefined, true)
                    ], 2)
                  ]),
                  metadata: _withCtx(({ entry, index }) => [
                    _createElementVNode("div", _hoisted_12, [
                      _renderSlot(_ctx.$slots, "item-metadata", {
                        entry: entry,
                        expanded: _ctx.expanded,
                        expand: (n, e) => _ctx.toggleExpandItem(entry, undefined, e),
                        cache: _ctx.cache,
                        actions: {},
                        elements: _ctx.elements,
                        index: _ctx.pageState.offset + index,
                        header: _ctx.name,
                        type: _ctx.type
                      }, undefined, true)
                    ])
                  ]),
                  body: _withCtx(({ entry, index }) => [
                    (!_ctx.expandable || _ctx.expanded.includes(entry.sys.id))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["column-item--content", {active: _ctx.expanded.includes(entry.sys.id)}])
                        }, [
                          _renderSlot(_ctx.$slots, "item-content", {
                            entry: entry,
                            expanded: _ctx.expanded,
                            expand: (n, e) => _ctx.toggleExpandItem(entry, undefined, e),
                            cache: _ctx.cache,
                            actions: {},
                            elements: _ctx.elements,
                            index: _ctx.pageState.offset + index,
                            header: _ctx.name,
                            type: _ctx.type
                          }, undefined, true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 3
                }, 8, ["class", "items"])
              ], true)
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 6))
}